import { ElxSpacing } from "@elixir/styling";
import { mergeStyles } from "@fluentui/react";
import { useTheme } from "@fluentui/react-theme-provider";
export const useTileStyles = () => {
    var _a, _b, _c;
    const theme = useTheme();
    const tileStyle = {
        root: [
            {
                "& h2": {
                    margin: "0px",
                    "& ul": {
                        marginTop: "0px",
                        marginLeft: "0rem",
                        paddingLeft: "1rem",
                    },
                },
                "& .tile-navigation": {
                    display: "block",
                    width: "calc(330px + 0.65rem)",
                    maxWidth: "100%",
                    textDecoration: "none !important",
                    color: "#292827 !important",
                    lineHeight: "18px",
                },
                "& .tile-section": {
                    display: "flex",
                    width: "100%",
                    minWidth: 0,
                    flexWrap: "wrap",
                    alignItems: "stretch",
                    border: "1px",
                    cursor: "pointer",
                    "& .tile:hover": {
                        backgroundColor: "rgb(245, 244, 243)",
                    },
                    "& .tile": {
                        margin: "0.325rem",
                        boxSizing: "border-box",
                        width: "330px",
                        minWidth: 0,
                        maxWidth: "calc(100% - 0.65rem)",
                        minHeight: "250px",
                        background: (_c = (_b = (_a = theme.tokens) === null || _a === void 0 ? void 0 : _a.color) === null || _b === void 0 ? void 0 : _b.brand) === null || _c === void 0 ? void 0 : _c.secondaryContentColor,
                        boxShadow: `0 calc(${ElxSpacing.space1} / 2) ${ElxSpacing.spaceHalf} rgba(0, 0, 0, 0.1)`,
                        borderRadius: "2px",
                        border: "0.01rem solid #e6e6e661",
                        "& .tile-heading-content": {
                            color: "#292827",
                        },
                        "& .tile-content": {
                            padding: "8px 12px 10px 12px",
                            display: "flex",
                            flexDirection: "column",
                            fontSize: "12px",
                            fontWeight: "400",
                            minHeight: "175px",
                            "& .tile-header": {
                                margin: 0,
                                fontFamily: "Segoe UI",
                                fontWeight: "600",
                                lineHeight: "22px",
                                fontSize: "16px",
                                "& .tile-navigation": {
                                    fontSize: "inherit",
                                    lineHeight: "inherit",
                                },
                            },
                            "& .tile-description": {
                                flex: "1 1 auto",
                                minHeight: "3rem",
                                marginTop: "0px",
                                paddingTop: "0.75rem",
                                margin: "0px",
                                "&.ul": {
                                    marginLeft: "0px",
                                    paddingLeft: "0px",
                                    textAlign: "left",
                                },
                            },
                            "& .tileSelectBtn": {
                                marginLeft: "12px",
                            },
                        },
                    },
                },
                "& .supported-links-section": {
                    marginLeft: `${ElxSpacing.spaceHalf}`,
                    marginTop: `${ElxSpacing.space1} * 4`,
                    "& .links": {
                        listStyle: "none",
                        paddingLeft: 0,
                    },
                    "& .link": {
                        textDecoration: "underline",
                        marginTop: `${ElxSpacing.spaceHalf} * 3`,
                        display: "block",
                        "& .link-color": {
                            color: theme.semanticColors.link,
                            "&:hover": {
                                color: theme.semanticColors.linkHovered,
                            },
                        },
                    },
                },
            },
        ],
    };
    return mergeStyles(tileStyle);
};
export const responsiveTileRootStyle = mergeStyles({
    selectors: {
        "@media (max-width: 1000px)": {
            width: "100%",
            minWidth: 0,
            maxWidth: "100%",
        },
    },
});
export const separateSelectLinkStyle = mergeStyles({
    lineHeight: "18px",
    "& .tile-section": {
        width: "calc(330px + 0.65rem)",
        maxWidth: "100%",
    },
    "& .tile": {
        position: "relative",
    },
    "& .tile-navigation": {
        width: "100%",
        position: "static",
    },
    // Extend the content link's pointer target without wrapping the Select link.
    "& .tile-navigation::before": {
        content: '""',
        position: "absolute",
        inset: "-0.325rem",
    },
    // Move the native outline to the card-wide pointer target.
    "& .tile-navigation:focus-visible": {
        outline: "none !important",
    },
    "& .tile-navigation:focus-visible::before": {
        outline: "3px solid Highlight",
    },
    "& .tileSelectBtn": {
        position: "relative",
        zIndex: 1,
    },
});
export const disabledTileStyle = mergeStyles({
    opacity: 0.5,
    cursor: "not-allowed",
    "& .tile-section": {
        pointerEvents: "none",
    },
});
/**
 * Green underglow applied DIRECTLY on the .tile element (not via descendant selectors).
 * This avoids the CSS specificity battle with useTileStyles() whose descendant selectors
 * (injected later during render) would otherwise override same-specificity rules.
 */
export const recommendedGlowClass = mergeStyles({
    boxShadow: "0 4px 20px rgba(16, 185, 129, 0.45) !important",
    border: "1.5px solid rgba(16, 185, 129, 0.6) !important",
    transition: "box-shadow 0.3s ease, border-color 0.3s ease",
    "@media (forced-colors: active)": {
        border: "2px solid Highlight !important",
        boxShadow: "none !important",
    },
});
/** Visually hidden but accessible to screen readers */
export const srOnlyStyle = mergeStyles({
    position: "absolute",
    width: 1,
    height: 1,
    overflow: "hidden",
    clip: "rect(0,0,0,0)",
    whiteSpace: "nowrap",
});
